<script>
import options from './StafetDonationTaendLysStepTwo.options'
export default options
</script>

<template>
  <article class="kb-stafet-step kb-stafet-donation-step-two">
    <h2 class="kb-stafet-step__title">
      {{ labels.taendEtLysCustomizeLysposeTitle }}
    </h2>

    <StafetLysPoserList
      :labels="StafetFlowLightBagsMetaListLabels"
      :numberOfDonations="donationAmount"
      :onChangeCallback="updateLightBagMeta"
      :displayInputError="displayInputError"
      :data="lysposeSubmissionModels"
      :isLysposerDedicated="isLysposerDedicated"
      :addPersonalNote="addPersonalNote"
    />

    <StafetActions
      :nextStepCallback="() => nextStepCallback(stepModel)"
      :nextStepLabel="labels.formNavigationNextStep"
      :previousStepCallback="() => previousStepCallback(stepModel)"
      :previousStepLabel="labels.formNavigationPrevStep"
    />
  </article>
</template>
